import EditBook from "../components/edit/EditBook";

export default function Edit() {
  return (
    <main className="py-6 2xl:px-6">
      <div className="container">
        <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
          <EditBook />
        </div>
      </div>
    </main>
  );
}
